import { supabase } from '../supabaseClient';

export const participationService = {
  async getParticipationData(editionYear) {
    try {
      console.log('Getting participation data for edition:', editionYear);
      
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        console.log(`Edition ${editionYear} not found`);
        throw new Error(`Edition ${editionYear} not found`);
      }

      console.log('Edition found:', edition);

      // Get participation data
      const { data: participationData, error: participationDataError } = await supabase
        .from('participation_data')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (participationDataError && participationDataError.code !== 'PGRST116') {
        console.error('Error getting participation data:', participationDataError);
      }

      console.log('Participation data:', participationData);

      return {
        participationHeader: {
          title: participationData?.participation_header_title || 'Participation au Congrès',
          subtitle: participationData?.participation_header_subtitle || ''
        },
        eventInfo: {
          title: participationData?.event_info_title || 'Informations sur l\'Événement',
          congressTitle: participationData?.event_congress_title || '',
          congressDates: participationData?.event_congress_dates || '',
          location: participationData?.event_location || '',
          subLocation: participationData?.event_sub_location || ''
        },
        countdownInfo: {
          title: participationData?.countdown_title || 'Compte à Rebours',
          targetDate: participationData?.countdown_target_date || '',
          targetTime: participationData?.countdown_target_time || '09:00',
          isActive: participationData?.countdown_is_active !== false
        },
        formInfo: {
          title: participationData?.form_title || 'Formulaire d\'Inscription',
          submitButtonText: participationData?.form_submit_button_text || 'S\'inscrire',
          registrationOpen: participationData?.registration_open !== false, // Add this line
          showParticipantForm: participationData?.show_participant_form !== false,
          showConferencierForm: participationData?.show_conferencier_form !== false
        },
        additionalInfo: {
          title: participationData?.additional_info_title || 'Informations Importantes',
          notes: participationData?.additional_info_notes ? 
            participationData.additional_info_notes.split('\n').filter(note => note.trim() !== '') : []
        },
        paymentPlans: participationData?.payment_plans || {
          presentiel: [
            { id: '1', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en présentiel' },
            { id: '2', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en présentiel' },
            { id: '3', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en présentiel' }
          ],
          online: [
            { id: '4', title: 'Étudiants PhD', price: '40 MAD', description: 'Accès complet en ligne' },
            { id: '5', title: 'Professeurs', price: '70 MAD', description: 'Accès complet en ligne' },
            { id: '6', title: 'Professionnels', price: '100 MAD', description: 'Accès complet en ligne' }
          ]
        }
      };
    } catch (error) {
      console.error('Error getting participation data:', error);
      throw error;
    }
  },

  async updateParticipationData(participationData, editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      const updateData = {
        edition_id: edition.id,
        participation_header_title: participationData.participationHeader?.title || 'Participation au Congrès',
        participation_header_subtitle: participationData.participationHeader?.subtitle || '',
        event_info_title: participationData.eventInfo?.title || 'Informations sur l\'Événement',
        event_congress_title: participationData.eventInfo?.congressTitle || '',
        event_congress_dates: participationData.eventInfo?.congressDates || '',
        event_location: participationData.eventInfo?.location || '',
        event_sub_location: participationData.eventInfo?.subLocation || '',
        countdown_title: participationData.countdownInfo?.title || 'Compte à Rebours',
        countdown_target_date: participationData.countdownInfo?.targetDate || null,
        countdown_target_time: participationData.countdownInfo?.targetTime || '09:00',
        countdown_is_active: participationData.countdownInfo?.isActive !== false,
        form_title: participationData.formInfo?.title || 'Formulaire d\'Inscription',
        form_submit_button_text: participationData.formInfo?.submitButtonText || 'S\'inscrire',
        registration_open: participationData.formInfo?.registrationOpen,  // Add this line
        show_participant_form: participationData.formInfo?.showParticipantForm,
        show_conferencier_form: participationData.formInfo?.showConferencierForm,
        additional_info_title: participationData.additionalInfo?.title || 'Informations Importantes',
        additional_info_notes: Array.isArray(participationData.additionalInfo?.notes) ? 
          participationData.additionalInfo.notes.join('\n') : 
          (participationData.additionalInfo?.notes || ''),
        payment_plans: participationData.paymentPlans || null,
        updated_at: new Date().toISOString()
      };

      // Try to update existing record first
      const { data: existingData } = await supabase
        .from('participation_data')
        .select('id')
        .eq('edition_id', edition.id)
        .single();

      if (existingData) {
        // Update existing record
        const { data, error } = await supabase
          .from('participation_data')
          .update(updateData)
          .eq('id', existingData.id)
          .select()
          .single();

        if (error) throw error;
        return data;
      } else {
        // Insert new record
        const { data, error } = await supabase
          .from('participation_data')
          .insert([updateData])
          .select()
          .single();

        if (error) throw error;
        return data;
      }
    } catch (error) {
      console.error('Error updating participation data:', error);
      throw error;
    }
  }
};
